import { useEffect, useMemo, useState } from "react";

export default class BaseListener {
    public static useListener() {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const listener = useMemo(() => new BaseListener(), []);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        listener.useListener();

        return listener;
    }

    private _listeners: (() => void)[] = [];

    public useListener() {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [, setUpdate] = useState({});

        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            const handler = () => {
                setUpdate({});
            };
            this.addListener(handler);
            return () => {
                this.removeListener(handler);
            };
        }, []);
    }

    public addListener(listener: () => void) {
        this._listeners.push(listener);
    }

    public removeListener(handler: () => void) {
        const index = this._listeners.findIndex(handler);
        if (index >= 0) {
            this._listeners.splice(index, 1);
        }
    }

    public updateListeners() {
        this._listeners.forEach(listener => listener());
    }

    public updateListners() {
        this.updateListeners();
    }
}
